<script lang="ts" setup>
import type { InstitutionFormOptions } from '~/components/Institution/CreateOrUpdate/Form.vue'
import type { UpdateOrCreateInstitution } from '~/types'

defineProps<{
  tab: Tab
  payload: UpdateOrCreateInstitution
  options?: InstitutionFormOptions
  isLoading?: boolean
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const saveHandler = (payload: UpdateOrCreateInstitution) => {
  emit('save', payload)
}
const closeHandler = () => {
  emit('close')
}
</script>

<template>
  <TheTab :tab="tab" :hide-title="true">
    <InstitutionCreateOrUpdateForm
      v-if="payload"
      :payload="payload"
      :is-loading="isLoading"
      :options="{ institutionRegistrationInputs: { byMobilePhone: true } }"
      @save="saveHandler"
      @cancel="closeHandler"
    />
  </TheTab>
</template>
